<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">{{total}} Sales</h4>
                                <h6 class="card-subtitle">List of sales available in your marketplace.</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'newsale'}"
                                                     class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Sale
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <!--                        <div class="col-md-12">-->
                        <!--                            <div class="form-group row">-->
                        <!--                                <div class="col-4">-->
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-4">
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :max-height="600"
                                            :options="buyers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchBuyers"
                                            class="form-control  multiselect-sm"
                                            id="buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            v-if="currentOrg.type === 'COOP'"
                                            v-model="filter.buyer">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Buyer not found</span>
                                    </multiselect>
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :max-height="600"
                                            :options="sellers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchSellers"
                                            class="form-control  multiselect-sm"
                                            id="seller"
                                            label="seller"
                                            name="seller"
                                            open-direction="bottom"
                                            placeholder="Search Seller"
                                            v-if="currentOrg.type === 'COOP_MEMBER'"
                                            v-model="filter.seller">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Seller not found</span>
                                    </multiselect>
                                </div>
                                <div class="col-4">
                                    <select class="custom-select" id="inlineFormCustomSelect"
                                            v-model="filter.status">
                                        <option value="">Choose Status</option>
                                        <option
                                                v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">{{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-4">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Sale Order #"
                                            type="text"
                                            v-model="filter.soid">
                                </div>
                            </div>
                            <div class="form-group row">

                                <div class="col-2">
                                    <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                                </div>

                                <div class="col-2">
                                    <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <div class="btn-group" style="display: flex;">
                                        <button @click="searchSo(1)"
                                                class="btn btn-light btn-outline-success font-weight-bold"
                                                style="flex: 1"
                                                type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()"
                                                class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                style="flex: 1" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>


                                <div class="col-2 text-right ml-auto">
                                    <!--                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ..."-->
                                    <!--                                      v-if="exporting">-->
                                    <!--                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>-->
                                    <!--                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>-->
                                    <!--                                        </span>-->
                                    <button aria-expanded="false" aria-haspopup="true"
                                            class="btn waves-effect waves-light btn-outline-info"
                                            data-toggle="dropdown" title="Operations">
                                        <i class="fa fa-grip-vertical"/>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="javascript:void(0)">
                                            <json-c-s-v
                                                    :data="sales_to_export"
                                                    :name="'Sale Report.csv'">
                                                Export as CSV
                                            </json-c-s-v>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="table-responsive m-t-30" v-if="sales.length>0">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <label class="col-form-label" for="records" style="padding-left: 10px;">Display
                                    Maximum</label>
                                <div class="col-sm-2" style="padding-top: 5px;">
                                    <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                            class="form-control form-control-sm" id="records" name="lang_opt_length"
                                            v-model="perPage">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <label class="col-form-label" for="records">Records per page</label>
                            </div>
                        </div>
                        <table class="table no-wrap v-middle">
                            <thead>
                            <tr class="border-0">
<!--                                <th class="border-0"><h6>#</h6></th>-->
                                <th class="border-0"><h6>Status</h6></th>
                                <th class="border-0"><h6>Number</h6></th>
                                <th class="border-0" v-if="currentOrg.type === 'COOP'"><h6>Buyer</h6></th>
                                <th class="border-0" v-if="currentOrg.type === 'COOP_MEMBER'"><h6>Seller</h6></th>
                                <th class="border-0"><h6>Amount</h6></th>
                                <th class="border-0"><h6>Created At</h6></th>
                                <th class="border-0"><h6>Actions</h6></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-bind:key="index" v-for="(s, index) in sales">
<!--                                <td>{{index+1}}</td>-->
                                <td>
                                    <dd class="mb-1">
                                        <p v-if="s.status === 'DRAFT'"><span class="label label-cyan">Draft</span>
                                        </p>
                                        <p v-if="s.status === 'CONFIRMED'"><span
                                                class="label label-primary">Confirmed</span>
                                        </p>
                                        <p v-if="s.status === 'INVOICED'"><span
                                                class="label label-indigo">Invoiced</span></p>
                                        <p v-if="s.status === 'DROP_SHIPMENT'"><span class="label label-brown">Drop Shipment</span>
                                        </p>
                                        <p v-if="s.status === 'BACK_ORDER'"><span
                                                class="label label-orange">Back Order</span>
                                        </p>
                                        <p v-if="s.status === 'PACKED'"><span
                                                class="label label-success">Packed</span></p>
                                        <p v-if="s.status === 'SHIPPED'"><span
                                                class="label label-light-green">Shipped</span>
                                        </p>
                                        <p v-if="s.status === 'FULFILLED'"><span class="label label-dark-green">Fulfilled</span>
                                        </p>
                                    </dd>
                                </td>
                                <td>{{s.id}}</td>
                                <td v-if="currentOrg.type === 'COOP'">{{s.buyer.biz_name | capitalize}}</td>
                                <td v-if="currentOrg.type === 'COOP_MEMBER'">{{s.seller.biz_name | capitalize}}</td>
                                <td>{{s.total | money}}</td>
                                <td>{{s.created_at | timestamp}}</td>
                                <td>
                                    <router-link :to="{'name': 'viewsale', params: {saleid: s.id}}">
                                        <i class="fas fa-eye m-10"></i>
                                    </router-link>
                                    <router-link :to="{'name': 'editsale', params: {saleid: s.id}}"
                                                 v-if="s.status === 'DRAFT'">
                                        <i class="fas fa-pencil-alt text-primary"></i>
                                    </router-link>
                                    <i @click="setRemoveProps(s.id)" class="far fa-trash-alt text-danger m-l-10"
                                       data-target="#confirmModal" data-toggle="modal" style="cursor: pointer"
                                       v-if="s.status === 'DRAFT'"></i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-body" v-else>
                        <h4 class="card-title text-muted text-center">No records found</h4>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this Sale Order?</h4>
                            <button @click="removeSale" class="btn waves-effect waves-light btn-success m-r-15"
                                    data-dismiss="modal" type="button">Yes
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import JsonCSV from 'vue-json-csv';

    export default {
        name: "Sales",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate, Multiselect, JsonCSV},
        data() {
            return {
                statuses: ['DRAFT', 'CONFIRMED', 'DROP_SHIPMENT', 'BACK_ORDER', 'PACKED', 'INVOICED', 'SHIPPED', 'FULFILLED', 'CLOSED'],
                buyers: [],
                sellers: [],
                filter: {
                    buyer: null,
                    seller: null,
                    status: "",
                    fromDate: "",
                    toDate: "",
                    soid: ""
                },
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                sales: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                perPage: 5,
                removeSaleId: null,
                sales_to_export: []
            };
        },
        mounted() {
            this.getSales(1);

            let self = this;
            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.fromDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.fromDate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.toDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.toDate = null;
                        }
                    });
            });
        },
        methods: {
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate = e[1].toDate();
            },
            async getSales(page) {
                $(".preloader").fadeIn();
                let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/sales", {
                    params: {
                        page: page,
                        perPage: this.perPage
                    }
                });

                $(".preloader").fadeOut();
                this.total = reply.data.total;
                this.sales = reply.data.sales;
                this.sales_to_export = reply.data.sales.map(s => ({
                    id: s.id,
                    status: s.status,
                    seller: s.seller.biz_name,
                    buyer: s.buyer.biz_name,
                    total: s.total.currency_symbol + ' ' + s.total.amount,
                    created_at: moment(s.created_at).format("MMMM Do YYYY")
                }))
                let max_date = reply.data.min_date;
                let min_date = reply.data.max_date;
                if (min_date && max_date) {
                    this.startDate = moment(max_date).format('YYYY-MM-DD');
                    this.endDate = moment(min_date).format('YYYY-MM-DD');
                } else if (this.sales.length === 1) {
                    this.startDate = moment(this.sales[0].created_at).format('YYYY-MM-DD');
                    this.endDate = moment(this.sales[0].created_at).format('YYYY-MM-DD');
                } else {
                    this.startDate = moment(new Date()).format('YYYY-MM-DD');
                    this.endDate = moment(new Date()).format('YYYY-MM-DD');
                }
                this.setPageCount();
            },
            pageHandler(pageNum) {
                this.getSales(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            viewSaleOrder(soid) {
                this.$router.push({name: "viewsale", params: {saleid: soid}});
            },
            viewTx(tx) {
                console.log(tx);
            },
            viewContract(contract) {
                console.log(contract);
            },
            async searchBuyers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/buyer/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.buyers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchSellers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/seller/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.sellers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchSo(page) {
                try {
                    this.filter.buyer = this.filter.buyer ? this.filter.buyer : {};
                    this.filter.seller = this.filter.seller ? this.filter.seller : {};
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${JSON.stringify(this.filter)}/search`, {
                            params: {
                                page: page,
                                perPage: 10
                            }
                        });
                    $(".preloader").fadeOut();
                    this.total = reply.data.total;
                    this.sales = reply.data.sales;
                    this.sales_to_export = reply.data.sales.map(s => ({
                        id: s.id,
                        status: s.status,
                        seller: s.seller.biz_name,
                        buyer: s.buyer.biz_name,
                        total: s.total.currency_symbol + ' ' + s.total.amount,
                        created_at: moment(s.created_at).format("MMMM Do YYYY")
                    }))
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.sales.length === 1) {
                        this.startDate = moment(this.sales[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.sales[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.setPageCount();
                } catch (e) {
                    console.log(e);
                }
            },
            async reset() {
                this.filter.buyer = null;
                this.filter.seller = null;
                this.filter.status = "";
                this.filter.fromDate = "";
                this.filter.toDate = "";
                this.filter.soid = "";
                await this.getSales(1);
            },
            perPageRecordChange() {
                this.getSales(1);
            },

            setRemoveProps(saleid) {
                this.removeSaleId = saleid;
            },
            async removeSale() {
                try {
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/sales/${this.removeSaleId}`);
                    this.$toastr('success', 'Invoiced deleted', 'Success');
                    await this.getSales(1);
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            }
        }
    }
</script>

<style scoped>
    .btn-arrange {
        margin-left: 4px !important;
    }

    .custom-go {
        height: 42px;
        margin-left: 5px;
    }
</style>
